import { useLocation } from 'react-router-dom';
import React from 'react';
import store from '@/stores';
import { fetchUserPoints2 } from '@/stores/slice/user';

/**
 * 监听路由变化
 */
export const RouterListener = React.memo<React.PropsWithChildren>(({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    store.dispatch(fetchUserPoints2());
  }, [location]);

  return <>{children}</>;
});
